import React from 'react';
import { getFileThumbSecond } from 'src/utils/getFileFormat';

const FileIcon = ({ type, url, size = 30 }) => {
  return getFileThumbSecond(type, url, { width: size, height: size });
};

export default FileIcon;
